import { Button, Card, CardActions, CardContent, CircularProgress, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { fetchAdminUsers } from 'actions/admin/UserActions';
import {
  clearNotification,
  clearWarehouse,
  createWarehouse,
  deleteWarehouse,
  fetchWarehouse,
  fetchWarehouseByID,
  getDataToAddWarehouse,
  updateWarehouse,
} from 'actions/admin/warehouseActions';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import TextFieldValidator from 'components/Form/TextFieldValidator';
import Header from 'components/Header/Header';
import SuccessSnackbar from 'components/Help/SuccessSnackbar';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import formFieldRegexValidations from '../../../utils/validatons';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm', 'md')]: {
      padding: 0,
      paddingTop: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  grid: {
    padding: 54,
  },
  card: {
    boxShadow: '6px 6px 6px #6C6C6C29',
    borderRadius: '15px',
    opacity: 1,
  },
  cardContent: {
    margin: '10px 20px',
  },
  cancelButton: {
    color: '#696969',
    //minWidth: "150px",
    fontWeight: '600',
    margin: '0px 55px 0px 0px',
  },
  dialog: {
    // border: '1px solid #707070',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  deleteButton: {
    color: '#FF6060 !important',
  },
  saveButton: {
    minWidth: '100px',
    color: '#40B5AD',
    fontWeight: 600,
    border: 2,
    boxShadow:
      '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
    //boxShadow: ' 6px 6px 6px #DEE5E7',
    borderRadius: '6px',
  },
  buttonsContainer: {
    '& > *': {
      margin: theme.spacing(1),
    },
    margin: '5px 49px',
    float: 'right',
  },
  dialogTitle: {
    marginTop: '25px',
    fontWeight: 600,
  },
  dialogAction: {
    marginTop: '45px',
  },
  font: {
    fontWeight: 600,
  },
  header: {
    backgroundColor: '#ffffff',
    boxShadow: '0px 3px 6px #00000029',
    padding: '20px 40px 15px',
    border: '1px solid #eeeeee',
    fontWeight: '600',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    fontSize: '0.9rem',
  },
  actions: {
    justifyContent: 'space-between',
    margin: '0 auto',
  },
  rows: {
    marginTop: 20,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const WarehouseDocumentsForm = (props) => {
  const {
    error,
    history,
    formLoading,
    warehouse,
    formSuccess,
    notification,
    fetchWarehouseByID,
    updateWarehouse,
    createWarehouse,
    clearNotification,
    getDataToAddWarehouse,
  } = props;
  const { id } = useParams();
  const defaultValues = {
    general_proposal_pdf_url: get(warehouse, 'general_proposal_pdf_url'),
    container_dropoff_pdf_url: get(warehouse, 'container_dropoff_pdf_url'),
    inbound_receivables_pdf_url: get(warehouse, 'inbound_receivables_pdf_url'),
    dispatch_orders_pdf_url: get(warehouse, 'dispatch_orders_pdf_url'),
    insurance_info_pdf_url: get(warehouse, 'insurance_info_pdf_url'),
  };

  let inputRef = React.createRef('form');
  const [values, setValues] = useState(defaultValues);
  const classes = useStyles();

  useEffect(() => {
    if (id) {
      fetchWarehouseByID(id);
    }
  }, [id]);

  useEffect(() => {
    props.fetchAdminUsers();
  }, []);

  useEffect(() => {
    const breadcrumbs = id && [
      {
        label: `Warehouse - ${warehouse.name}`,
        path: `/admin/warehouses/${id}`,
      },
      {
        label: `Documents`,
        path: null,
      },

    ];
    handleGenerateBreadcrumbs(breadcrumbs);
  }, [id, warehouse]);

  const handleChange = (event, val, name) => {
    const newValues = {
      ...values,
      [name || event.target.name]: val || event.target.value,
    };
    setValues(newValues);
  };

  const submitForm = () => {
    if (id) {
      const newValues = { ...values, ['id']: id };
      setValues(newValues);
      const dataToSubmit = { warehouse: values };
      updateWarehouse(id, dataToSubmit);
    } else {
      let dataToSubmit = { warehouse: { ...values } };
      createWarehouse(dataToSubmit);
    }
  };
  useEffect(() => {
    if (id) {
      fetchWarehouseByID(id);
    }
    getDataToAddWarehouse();
  }, []);

  useEffect(() => {
    if (formSuccess) {
      history.push(`/admin/warehouses/${id}/summary`);
    }
  }, [formSuccess]);

  useEffect(() => {
    if (id && warehouse.name) {
      setValues(warehouse);
    }
  }, [warehouse]);

  const location = useLocation();

  const [breadcrumbs, setBreadcrumbs] = useState([
    {
      label: 'Hello',
      path: location.pathname,
    },
  ]);

  const handleGenerateBreadcrumbs = (values) => {
    setBreadcrumbs(values);
  };

  const generateTitle = 'Edit Warehouse Documents';

  return (
    <div className={classes.root}>
      <div>
        <div>
          <Breadcrumbs label='Warehouses' breadcrumbs={breadcrumbs}/>
        </div>
        <Header subtitle={''}/>
      </div>

      <Grid className=''>
        <SuccessSnackbar
          open={error || notification ? true : false}
          error={error ? error.error_message || error.error || error : null}
          messageText={notification}
          onClose={() => clearNotification()}
        />

        <Card className={classes.card}>
          <div className={classes.header}>
            <span>{generateTitle}</span>
          </div>
          <ValidatorForm
            ref={inputRef}
            onError={(errors) => console.log(errors)}
            onSubmit={() => submitForm()}
          >
            <CardContent>
              <Grid container justify='flex-start'>
                {formFields.map((column, i) => (
                  <Grid
                    item
                    sm={column.fullWidth ? 10 : 5}
                    xs={12}
                    alignContent='center'
                    className={classes.cardContent}
                  >
                    <TextFieldValidator
                      keyVal={`${column.value}_${i}`}
                      classNames={classes.rows}
                      required={
                        column.required && !column.errorMessages ? true : false
                      }
                      validators={column.required}
                      errorMessages={column.errorMessages}
                      id={column.value}
                      label={column.label}
                      value={values[column.value] || ''}
                      onChange={handleChange}
                      helperText={column.helperText}
                      errors={error}
                      options={column.options}
                      select={column.select}
                      optionValue={column.optionValue}
                      optionText={column.optionText}
                    />
                  </Grid>
                ))}
              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction='row'
                justify='flex-end'
                alignItems='center'
                sm={11}
                xs={12}
                className={classes.cardContent}
              >
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  container
                  direction='row'
                  justify='flex-end'
                  alignItems='center'
                >
                  <Link
                    to={`/admin/warehouses/${id}/summary`}
                  >
                    <Button
                      className={classes.cancelButton}
                      color='secondary'
                      disabled={formLoading}
                    >
                      Cancel
                    </Button>
                  </Link>
                  <Button
                    variant='contained'
                    type='submit'
                    className={classes.saveButton}
                    disabled={formLoading}
                  >
                    Save
                    {formLoading && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </CardActions>
          </ValidatorForm>
        </Card>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  loading: state.warehouseReducer.loading,
  error: state.warehouseReducer.error,
  warehouses: state.warehouseReducer.warehouses,
  locations: state.warehouseReducer.locations,
  locationDetail: state.warehouseReducer.location,
  warehouse: state.warehouseReducer.warehouse,
  pagination: state.warehouseReducer.pagination,
  notification: state.warehouseReducer.notification,
  dutyDetails: state.warehouseReducer.fetchedWarehouse,
  formLoading: state.warehouseReducer.formLoading,
  formSuccess: state.warehouseReducer.formSuccess,
  filter: state.warehouseReducer.filter,
  dummyData: state.warehouseReducer.dummyData,
  barcode: state.warehouseReducer.barcode,
  filename: state.warehouseReducer.filename,
  activeFilter: state.warehouseReducer.activeFilter,
  countries: state.adminAuthReducer.countries,
  users: state.warehouseReducer.users,
  adminUsers: state.adminUsersReducer.users,
});

function mapDispatchToProps(dispatch) {
  return {
    fetchWarehouses: (params) => dispatch(fetchWarehouse(params)),
    clearWarehouse: () => dispatch(clearWarehouse()),
    createWarehouse: (data) => dispatch(createWarehouse(data)),
    updateWarehouse: (id, data) => dispatch(updateWarehouse(id, data)),
    fetchWarehouseByID: (id) => dispatch(fetchWarehouseByID(id)),
    getDataToAddWarehouse: () => dispatch(getDataToAddWarehouse()),
    clearNotification: () => dispatch(clearNotification()),
    deleteWarehouse: (id) => dispatch(deleteWarehouse(id)),
    fetchAdminUsers: () => dispatch(fetchAdminUsers()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseDocumentsForm);



const baseFieldConfig = {
  required: [
    'required',
    formFieldRegexValidations.urlRegexMatchUp
  ],
  errorMessages: ['required', 'Link is not valid'],
  fullWidth: true,
};

const formFields = [
  {
    value: 'general_proposal_pdf_url',
    label: 'General Proposal',
    fullWidth: true,
    ...baseFieldConfig,
  },
  {
    value: 'container_dropoff_pdf_url',
    label: 'Container Dropoff',
    ...baseFieldConfig,
  },
  {
    value: 'inbound_receivables_pdf_url',
    label: 'Inbound Receivables',
    ...baseFieldConfig,
  },
  {
    value: 'dispatch_orders_pdf_url',
    label: 'Dispatch Orders',
    ...baseFieldConfig,
  },
  {
    value: 'insurance_info_pdf_url',
    label: 'Insurance Information',
    ...baseFieldConfig,
  },
];
